var url = {};
var host = "";
var host_proxy_8080 = "proxy_8080";
var api_host = "/";

url.host = host;
url.commonRoot =  window.commonRoot;
url.casRoot = window.casRoot;
url.hyqtRoot = window.hyqtRoot;
url.clinicRoot = window.clinicRoot;
url.listRoot = window.listRoot;
url.busRoot = window.busRoot;
url.cartRoot= window.cartRoot;
url.myClinic = window.myClinic;
url.college = window.college;
url.renZheng = window.renZheng;
url.nginxRoot = window.nginxRoot;
if(process.env.NODE_ENV === 'production'){
    host = window.commonRoot;
    url.static = "/resources/static";
    url.userId = "";

    url.saveFeedbackPicture = host + "/sso/feedback/saveFeedbackPicture";
    url.saveFeedbackInfo = host + "/sso/feedback/saveFeedbackInfo";
    url.getFeedbackInfo = host + "/sso/feedback/getFeedbackInfo";
    url.saveFeedbackEvaluate = host + "/sso/feedback/saveFeedbackEvaluate";
    url.getUserMobile = host + "/sso/feedback/getUserMobile";
}else{
    host = "/" + host_proxy_8080;
    url.static = "/static";
    url.userId = "360";

    url.saveFeedbackPicture = host + "/feedback/saveFeedbackPicture";
    url.saveFeedbackInfo = host + "/feedback/saveFeedbackInfo";
    url.getFeedbackInfo = host + "/feedback/getFeedbackInfo";
    url.saveFeedbackEvaluate = host + "/feedback/saveFeedbackEvaluate";
    url.getUserMobile = host + "/feedback/getUserMobile";
}

url.loginUrl = window.casRoot+ "/login?service="+ encodeURIComponent(window.commonRoot +"/sso/toSSoLogin.do?targeturl=" + window.location.href);
url.registerUrl =  window.casRoot+ "/register?service="+ encodeURIComponent(window.commonRoot +"/sso/toSSoLogin.do?targeturl=" + window.location.href);
url.departmentList = host + "/dynamic/js/departmentList.js";
url.locationList = host + "/dynamic/js/locationList.js";
url.getAdvertisement = host + "/advertisement/getAdvertisement.do";
url.getHotWord = host + "/hotWord/getHotWord.do";
url.getBannerInfo = host + "/banner/getBannerInfo.do";
url.getClinicInfo = host + "/homePageclinic/getClinicInfo.do";
url.getOpenCitySite = host + "/citySite/getOpenCitySite.do";
url.locationCity = host + "/citySite/locationCity.do";
url.getUserInfo = host + "/login/c/getUserInfo";
url.getInformation = host + "/infomation/getInformation.do";
url.getProductInfo = host + "/product/getProductInfo.do";
url.getCartNum = host + "/cartInterface/c/getCartNum";
url.getAboutLink = host + "/pagefoot/getAboutLink";
url.checkCitysiteAndGetCity = host + "/citySite/checkCitysiteAndGetCity";
url.etTicket = host + "/sso/getTicket";
url.imgUpload = host + "/posts/";
url.findMessage = host + "/messageInterface/findMessage.do";
url.forgotPassword = window.casRoot + "/forgotPassword";
url.getPicCheckFlag = host + "/login/getPicCheckFlag.do";
url.loginByMobile = host + "/login/loginByMobile.do";
url.loginByWeb = host + "/login/loginByWeb.do";
url.loginSSO = window.commonRoot + "/login/loginSSO.do";
url.sendSmsCode = host + "/login/sendSmsCode.do";

url.districtList = host + '/area/districtList.do';
url.doctorPage = host +　'/doctorPage/list.do'
url.department = host + '/department/list.do'
url.clinicPage = host +　'/clinicPage/list.do'
url.getRecomentProduct = window.listRoot + '/wjPrdDetail/getRecomentProduct.do';

url.deleteDoctorConcern = host + '/doctorInterface/deleteDoctorConcern.do';
url.insertDoctorConcern = host + '/doctorInterface/insertDoctorConcern.do';
url.deleteClinicConcern = host + '/clinicInterface/deleteClinicConcern.do';
url.insertClinicConcern = host + '/clinicInterface/insertClinicConcern.do';

url.getDoctorMedicineTitleList = host + '/doctorPage/getDoctorMedicineTitleList.do';
export default url;




//////////////////
// WEBPACK FOOTER
// ./config/url.js
// module id = FKvS
// module chunks = 1